export default "/_next/static/273e44045a6c1ad044666b9490981a08.png";